import React from 'react'
import AdmJournalReport from '../../components/AdminTabs/AdminJournalReport/AdmJournalReport'

const JournalReport = () => {
  return (
    <div>
        <AdmJournalReport/>
    </div>
  )
}

export default JournalReport